import React from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { 
  MapPin, 
  Phone, 
  Mail, 
  Clock, 
  Instagram, 
  Facebook, 
  Twitter,
  Youtube,
  Heart
} from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { mockData } from '../mock';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();
  const location = useLocation();

  const handleSocialClick = (platform) => {
    const urls = {
      instagram: 'https://instagram.com/cresence.skin',
      facebook: 'https://www.facebook.com/share/1Bjp2gA3pz/',
      twitter: 'https://twitter.com/cresence.skin',
      youtube: 'https://www.youtube.com/share/1Bjp2gA3pz/',
      // call: '+91 74900 20099',
      // whatsapp:'+91 74900 20099',
    };
    window.open(urls[platform], '_blank');
  };

  const handleQuickLink = (link) => {
    if (link.startsWith('#')) {
      // Check if we're on the home page
      if (location.pathname === '/') {
        // We're on home page, just scroll to the section
        const element = document.querySelector(link);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      } else {
        // We're on a different page, navigate to home first with the section hash
        navigate('/', { state: { scrollTo: link } });
      }
    } else if (link === 'privacy') {
      navigate('/privacy-policy');
    } else if (link === 'terms') {
      navigate('/terms-conditions');
    } else {
      // External link or other actions
      alert(`Navigating to ${link}... This will be implemented in the full version!`);
    }
  };

   const handleCall = () => {
    window.open(`tel:${mockData.clinic.phone}`, '_self');
  };

  const handleWhatsApp = () => {
    const message = `Hi! I'm interested in booking a consultation at ${mockData.clinic.name}.`;
    window.open(`https://wa.me/${mockData.clinic.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`, '_blank');
  };

  return (
    <footer className="bg-sage text-white">
      <div className="container mx-auto !px-4 !py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Clinic Info */}
          <div className="space-y-6">
            <div className="flex items-center space-x-3">
               <img
                src="/images/logo-invert-transperant.svg"
                alt="Clinic Logo"
                className="object-contain"
              />
            </div>
            
            <p className="text-cream/80 text-sm leading-relaxed">
              Your trusted partner for advanced skincare treatments in Surat. 
              We combine expertise with compassion to deliver exceptional results.
            </p>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => handleSocialClick('instagram')}
                className="w-10 h-10 bg-cream/20 rounded-full flex items-center justify-center hover:bg-mint transition-colors"
              >
                <Instagram size={18} />
              </button>
              <button 
                onClick={() => handleSocialClick('facebook')}
                className="w-10 h-10 bg-cream/20 rounded-full flex items-center justify-center hover:bg-mint transition-colors"
              >
                <Facebook size={18} />
              </button>

              <button 
                onClick={handleWhatsApp}
                className="w-10 h-10 bg-cream/20 rounded-full flex items-center justify-center hover:bg-mint transition-colors"
              >
                <FaWhatsapp size={18} />
              </button>
              <button 
                onClick={handleCall}
                className="w-10 h-10 bg-cream/20 rounded-full flex items-center justify-center hover:bg-mint transition-colors"
              >
                <Phone size={18} />
              </button>
              {/* <button 
                onClick={() => handleSocialClick('twitter')}
                className="w-10 h-10 bg-cream/20 rounded-full flex items-center justify-center hover:bg-mint transition-colors"
              >
                <Twitter size={18} />
              </button>
              <button 
                onClick={() => handleSocialClick('youtube')}
                className="w-10 h-10 bg-cream/20 rounded-full flex items-center justify-center hover:bg-mint transition-colors"
              >
                <Youtube size={18} />
              </button> */}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-cream">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', link: '#home' },
                { name: 'About Us', link: '#about' },
                { name: 'Treatments', link: '#treatments' },
                // { name: 'Treatment Packages', link: '#treatment-packages' },
                { name: 'Gallery', link: '#gallery' },
                { name: 'Testimonials', link: '#testimonials' },
                // { name: 'Blog', link: '#blog' },
                { name: 'Offers', link: '#offers' },
                { name: 'FAQs', link: '#faq' },
                { name: 'Contact', link: '#contact' }
              ].map((item) => (
                <li key={item.name}>
                  <button
                    onClick={() => handleQuickLink(item.link)}
                    className="text-cream/80 hover:text-cream transition-colors"
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-cream">Our Services</h4>
            <ul className="space-y-3">
              {mockData.treatments.map((treatment) => (
                <li key={treatment.id}>
                  <button
                    onClick={() => handleQuickLink('#treatments')}
                    className="text-cream/80 hover:text-cream transition-colors"
                  >
                    {treatment.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-cream">Contact Info</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="text-mint mt-1 flex-shrink-0" size={18} />
                <p className="text-cream/80 text-sm">{mockData.clinic.address}</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <Phone className="text-mint flex-shrink-0" size={18} />
                <p className="text-cream/80 text-sm">{mockData.clinic.phone}</p>
              </div>
              
              <div className="flex items-center space-x-3">
                <Mail className="text-mint flex-shrink-0" size={18} />
                <p className="text-cream/80 text-sm">{mockData.clinic.email}</p>
              </div>
              
              <div className="flex items-start space-x-3">
                <Clock className="text-mint mt-1 flex-shrink-0" size={18} />
                <div className="text-cream/80 text-sm">
                  <p>Mon-Fri: {mockData.clinic.timings.weekdays}</p>
                  <p>Sat: {mockData.clinic.timings.saturday}</p>
                  <p>Sun: {mockData.clinic.timings.sunday}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-cream/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex items-center space-x-2 text-cream/80 text-sm">
              <span>© {currentYear} {mockData.clinic.name}. All rights reserved.</span>
              <Heart className="text-red-300" size={16} />
            </div>
            
            <div className="flex space-x-6 text-sm">
              <Link
              to={'/privacy-policy'}
                className="text-cream/80 hover:text-cream transition-colors"
              >
                Privacy Policy
              </Link>
              <Link 
                to={'/terms-conditions'}
                className="text-cream/80 hover:text-cream transition-colors"
              >
                Terms of Service
              </Link>
              {/* <button
                onClick={() => handleQuickLink('sitemap')}
                className="text-cream/80 hover:text-cream transition-colors"
              >
                Sitemap
              </button> */}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;